import "bootstrap/dist/css/bootstrap.min.css";
import "./tailwind.css";
import "@hdir/ui/style.css";
import "./i18n";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ThemeProvider } from "styled-components";

import App from "./App";
import { GlobalStyle } from "./components/style/global";
import { theme } from "./components/style/theme";

const root = createRoot(document.querySelector("#root") as HTMLElement);
root.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <App />
    </ThemeProvider>
  </StrictMode>
);
